import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "./ImportantUpdates.css";
import Cross from "../../../../assets/images/onboardingImages/crossBlack.svg";
import Arrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import CopyLogo from "../../../../assets/images/onboardingImages/logo_black.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ImportantUpdates = () => {
  const { state:locationState } = useLocation();
  const [show, setShow] = useState(true); // Modal visibility
  const [email, setEmail] = useState("");
  const { user } = useSelector((state) => state.user);
  const isOnBoardingComplete =
  user?.onboarding?.isCommunityCreated &&
  user?.onboarding?.connect &&
  user?.onboarding?.payment &&
  user?.onboarding?.subscribed &&
  user?.onboarding?.isVerified;
  const handleClose = () => {
    navigate("/leader/dashboard", { replace: true });
    setShow(false);
  };

  const navigate = useNavigate();

  const noClickButton = () => {
    navigate("/leader/onboarding/submitNewEmail", { replace: true });
  };

  const yesClickButton = () => {
    navigate("/leader/onboarding/setupComplete", { replace: true });
  };

  useEffect(() => {
    if (user) {
      const email = user?.email || user?.socialLogin?.discord?.email;
      setEmail(email);
    }
  }, [user]);
 useEffect(()=>{
  if(!locationState&&!(locationState?.from==="onboarding")){
    navigate("/leader/dashboard", { replace: true });
    return;
 }
 },[])
  // if(isOnBoardingComplete){
  //   navigate("/leader/dashboard", { replace: true });
  //   return;
  //  }
  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="custom-onboarding-modal"
        backdropClassName="onboarding-custom-backdrop"
      >
        <Modal.Body>
          <button
            type="button"
            className="reverseArrow"
            onClick={() => {
              navigate("/leader/onboarding/payout", { replace: true });
            }}
          >
            <img src={Arrow} alt="Arrow Image" />
          </button>
          <button type="button" className="CrossIcon" onClick={handleClose}>
            <img src={Cross} alt="Cross Image" />
          </button>
          <div className="onboardingContentBox top77px">
            <h2 className="title">
              <span>Important Updates</span>
            </h2>
            <p className="desc bottom50px">Is this the email we should use?</p>
            <div className="formBox">
              <div className="mb-20px">
                <FloatingTextFiled
                  className="onboardingInput"
                  label="Email"
                  placeholder="Email"
                  type="Text"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  disabled
                />
              </div>
              <button
                type="button"
                className="ExtraTierBtn"
                onClick={yesClickButton}
              >
                Yes
              </button>
              <button type="button" className="NextBtn" onClick={noClickButton}>
                No
              </button>
            </div>
          </div>
          <div className="paginationDots">
            <button className="dot "></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot active"></button>
            <button className="dot "></button>
            <button className="dot "></button>
          </div>
          <div className="copyrightBox">
            <p className="">
              Powered by{" "}
              <span className="spanMain">
                <img src={CopyLogo} alt="" />
              </span>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ImportantUpdates;
